import { z } from 'zod';

export const englishIqHistoryItemSchema = z.object({
  cefr: z.string(),
  createdAt: z.number().int(),
  durationMs: z.number().int().nonnegative(),
  itemCount: z.number().int().nonnegative(),
  score: z.number().int(),
  shareId: z.string(),
  subBand: z.string(),
});

export type IEnglishIqHistoryItem = z.infer<typeof englishIqHistoryItemSchema>;
